export * from "./useProductDetails";
